import { RootState } from '../../../../stores/store';

export const navbarSelector = (state: RootState) => state.navbar;
